<!-- eslint-disable -->
<template>
  <v-container class="page-container">
    <v-row justify="center">
      <v-col cols="12" md="10" lg="8">
        <!-- Loading -->
        <div v-if="loading" class="text-center py-8">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        
        <!-- Error -->
        <v-alert v-else-if="error" type="error" class="my-4">
          {{ error }}
        </v-alert>
        
        <!-- Page Content -->
        <v-card v-else-if="page" elevation="1">
          <v-card-title class="text-h4 py-6">
            {{ page.title }}
          </v-card-title>
          
          <v-card-text class="page-content" v-html="page.content"></v-card-text>
          
          <v-card-actions class="text-caption text-grey pa-4">
            {{ $t('pages.lastUpdated') }}: {{ formatDate(page.updated_at) }}
          </v-card-actions>
        </v-card>
        
        <!-- Not Found -->
        <v-alert v-else type="info" class="my-4">
          {{ $t('pages.notFound') }}
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
/* eslint-disable */
import { ref, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import api from '../services/api'

const route = useRoute()
const { locale } = useI18n()

const page = ref(null)
const loading = ref(true)
const error = ref(null)

const loadPage = async () => {
  const slug = route.params.slug
  if (!slug) return
  
  loading.value = true
  error.value = null
  
  try {
    const response = await api.get('/pages', {
      params: { slug, locale: locale.value }
    })
    page.value = response.data.page
  } catch (err) {
    console.error('Error loading page:', err)
    if (err.response?.status === 404) {
      page.value = null
    } else {
      error.value = err.response?.data?.error || 'Failed to load page'
    }
  } finally {
    loading.value = false
  }
}

const formatDate = (dateStr) => {
  if (!dateStr) return ''
  const date = new Date(dateStr)
  return date.toLocaleDateString(locale.value, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}

// Load on mount and when route or locale changes
onMounted(loadPage)
watch(() => route.params.slug, loadPage)
watch(locale, loadPage)
</script>

<style scoped>
.page-container {
  max-width: 900px;
  margin: 0 auto;
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.page-content {
  font-size: 1rem;
  line-height: 1.7;
}

.page-content :deep(h2) {
  font-size: 1.5rem;
  font-weight: 600;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  color: rgb(var(--v-theme-primary));
}

.page-content :deep(h3) {
  font-size: 1.25rem;
  font-weight: 600;
  margin-top: 1.25rem;
  margin-bottom: 0.75rem;
}

.page-content :deep(p) {
  margin-bottom: 1rem;
}

.page-content :deep(ul),
.page-content :deep(ol) {
  margin-bottom: 1rem;
  padding-left: 1.5rem;
}

.page-content :deep(li) {
  margin-bottom: 0.5rem;
}

.page-content :deep(a) {
  color: rgb(var(--v-theme-primary));
  text-decoration: underline;
}
</style>